var styles = {"article":"HeaderName-module_article__-dT0a"};

export { styles as default };
